import { ProgramDialogAction } from '../../types';
import React, { useEffect, useRef, useState } from 'react';
import { useAsyncDebounce } from 'react-table';
import { DebounceMsConfig } from '../../../config';
import { Form } from 'react-bootstrap';
import clsx from 'clsx';
import { ErrorMessage } from 'formik';

export const ProgramEditName = ({
  initialValue,
  setValue,
  disabled,
  readonly,
  isInvalid,
  isCampaign,
  action,
  scrollToTaskId,
  isSocialPosting,
}: {
  initialValue: string;
  setValue: (s: string) => void;
  disabled: boolean;
  readonly: boolean;
  isCampaign: boolean;
  isInvalid: boolean;
  action: ProgramDialogAction;
  scrollToTaskId: string | null;
  isSocialPosting: boolean;
}) => {
  const inputNameRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    if (!disabled && scrollToTaskId === null) inputNameRef.current?.focus();
  }, [action, disabled, scrollToTaskId]);
  const [currentValue, setCurrentValue] = useState(initialValue ?? '');
  const onChange = useAsyncDebounce((v) => {
    setValue(v ?? undefined);
  }, DebounceMsConfig.programEditInputDebounceMs);

  useEffect(() => {
    setCurrentValue(initialValue || '');
  }, [initialValue]);

  function handleChange(v: string | null) {
    setCurrentValue(v ?? '');
    onChange(v);
  }

  return (
    <div className="d-flex align-items-center w-100" style={{ marginTop: '24px' }}>
      <Form.Group controlId="name" className="w-100">
        <input
          type="text"
          autoComplete="off"
          ref={inputNameRef}
          value={currentValue}
          placeholder={
            isCampaign
              ? 'Add campaign name'
              : isSocialPosting
              ? 'Add internal social post name'
              : 'Add program name'
          }
          onChange={(e) => handleChange(e.target.value)}
          disabled={disabled}
          readOnly={readonly}
          data-test="program-edit__name"
          className={clsx('program-edit__input-redesigned--name w-100', {
            'is-invalid': isInvalid,
          })}
        />
        <ErrorMessage
          component="div"
          name="name"
          className="invalid-feedback"
          data-test="program-edit__name-validation-error"
        />
      </Form.Group>
    </div>
  );
};
